var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-content",class:_vm.is_dark ? 'section-content--dark' : ''},[(_vm.is_number)?_c('span',{staticClass:"content-number"},[_vm._v(_vm._s(_vm.number))]):_vm._e(),_c('div',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"content-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }